// Every date in this module renders as DD/MM/YYYY with leading zeros, on every
// device. `toLocaleDateString()` follows the browser/OS locale, so the same form
// showed 7/31/2026 on an en-US desktop and 31/7/2026 on an en-GB/en-IN phone.

const pad = (value) => String(value).padStart(2, "0");

// `new Date(null)` is the epoch and `new Date("")` is Invalid Date — an absent
// value is neither, it is simply nothing to show.
const toDate = (value) => {
  if (!value) return null;
  return value instanceof Date ? value : new Date(value);
};

const isValid = (date) => date instanceof Date && !isNaN(date.getTime());

// DD/MM/YYYY read in the viewer's timezone (what toLocaleDateString did).
export function formatDate(value) {
  const date = toDate(value);
  if (!isValid(date)) return "";

  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`;
}

// DD/MM/YYYY HH:MM:SS read off the UTC fields. Used for values that already had
// an offset baked in (see UTCtoISTFormat), where the UTC fields hold the wall
// clock time we want to show.
export function formatUtcDateTime(value) {
  const date = toDate(value);
  if (!isValid(date)) return "";

  const day = `${pad(date.getUTCDate())}/${pad(
    date.getUTCMonth() + 1
  )}/${date.getUTCFullYear()}`;
  const time = `${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}:${pad(
    date.getUTCSeconds()
  )}`;

  return `${day} ${time}`;
}
